import { render, staticRenderFns } from "./dklb.vue?vue&type=template&id=1d391fdb&scoped=true"
import script from "./dklb.vue?vue&type=script&lang=js"
export * from "./dklb.vue?vue&type=script&lang=js"
import style0 from "./dklb.vue?vue&type=style&index=0&id=1d391fdb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d391fdb",
  null
  
)

export default component.exports